import React from 'react';
import { useAtomValue } from 'jotai';
import TRC_CONTENT from '@/constants/trcContentType';
import { bottomSidebarItems, getItemLabel, getItemPath } from '@/Layouts/UserLayout/components/sidebarItem';
import { userInfoAtom } from '@/data/atoms/utilsAtoms';
import { UpgradeButton } from '@/atomicComponent/UpgradeButton';
import { Link } from 'react-router-dom';

const SidebarBottomItems = ({ apiStatus, isSidebarCollapsed }) => {
	const userData = useAtomValue(userInfoAtom);
	return (
		<>
			<div className="nav-item ps-1" style={{ marginLeft: '0.63rem', marginBottom: '0.63rem' }}>
				{!isSidebarCollapsed && <UpgradeButton />}
			</div>
			{bottomSidebarItems.map(item => {
				if (!userData.token || (item.isSubscriptionRequired && !apiStatus)) {
					return null;
				}
				const itemPath = getItemPath(item, userData);
				const itemLabel = getItemLabel(item, userData);
				return (
					<li className="nav-item ps-1" key={item.key}>
						<Link
							to={itemPath}
							target={item.external ? '_blank' : '_self'}
							rel={item.external ? 'noopener noreferrer' : ''}
							style={{ color: item.key === TRC_CONTENT.TRC ? '#73CFF3' : '#71717a' }}
						>
							<div className="custom-home-icon">{React.createElement(item.icon)}</div>
							<span
								style={{
									color: item.key === TRC_CONTENT.TRC ? '#73CFF3' : '#71717a',
									fontSize: item.key === TRC_CONTENT.TRC ? '0.7rem' : '0.75rem'
								}}
							>
								{itemLabel}
							</span>
						</Link>
					</li>
				);
			})}
		</>
	);
};

export default SidebarBottomItems;
